import React from 'react';
import imageOnError from '../helpers/imgOnError.js';

interface DomainPageHeader {
    Domain: string;
    Title: string;
}

interface WebsiteSecondaryPageTitleProps {
    domainPageHeader?: DomainPageHeader;
}

export default function WebsiteSecondaryPageTitle({ domainPageHeader }: WebsiteSecondaryPageTitleProps) {

	if (!domainPageHeader) return (<></>);

	return (<>
        <br/>
        <div className="container">
            <div className="row row-50">
                <div className="col-md-12 col-lg-12 col-xl-12">
                    <h2 className="word-break">
                        <img 
                            width="16"
                            height="16"
                            src={`https://www.google.com/s2/favicons?domain=${domainPageHeader.Domain}`} 
                            onError={imageOnError}
                        />
                        {' '}{domainPageHeader.Domain}
                        {/* No <Link>! this is external reference 
                        <a 
                            target="_blank" 
                            rel="noopener nofollow noreferrer" 
                            href={`http://${domainPageHeader.Domain}/`}
                        >
                            {' '}
                            <span style={{color:'black'}}
                                className="icon text-right fa fa-external_link">
                            </span>                       
                        </a>      
                        */}                 
                    </h2>
                    {domainPageHeader.Title}
                </div>
            </div>       
        </div> 
	</>)
}
